import styled from 'styled-components';
import { singleLineText, flexCenter } from '../../../../helpers/style-helpers';
import theme from '../../../../constants/theme';
import { Link } from 'react-router-dom';

export const PatientsSC = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;

  .section-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f5f7;
    margin-left: 2px;
    padding: 8px 16px;
    color: rgba(24, 30, 52, 0.5);
    font-size: 14px;
    font-weight: 600;
  }

  .content-scrollable {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 16px;
  }

  .patients-show-all {
    padding: 30px 16px;
    text-align: center;
  }
`;

export type TPatientSC = {
  isImportant?: boolean;
  isUnread?: boolean;
};
export const PatientSC = styled(Link)`
  display: flex;
  position: relative;
  align-items: center;

  padding: 16px 24px;
  margin: 16px 0;

  box-shadow: ${({ theme }) => theme.shadows.low};
  background-color: ${({ theme }) => theme.color.surface.baseline};
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    text-decoration: none;
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.baseline, 'hover')};
  }

  .p-avatar {
    position: relative;
    margin-right: 20px;
  }
`;

export const NoPatientsSC = styled.div`
  ${flexCenter}

  flex: 1;
  flex-direction: column;
  text-align: center;
  margin-top: 20px;

  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    opacity: 0.2;
    max-width: 276px;
    margin-bottom: 24px;
  }
`;
